// extracted by mini-css-extract-plugin
module.exports = {"md":"home-tabbar-item_md_2bvaE","ios":"home-tabbar-item_ios_3poOT","link":"home-tabbar-item_link_V8YY4"};